const LabelTypes = {
    "default": "default",
    "red": "red",
    "green": "green",
    "purple": "purple",
    "gray": "gray"
};
var label_types = Object.freeze(LabelTypes);

export { label_types as default };
//# sourceMappingURL=label_types.js.map
